export const isAdmin = (addr: string | undefined): boolean => {
  if (addr) {
    return process.env.REACT_APP_ADMIN_LIST?.includes(addr) ?? false;
  }

  return false;
};
